'use client'
import { FC, useEffect, useState} from "react";
import { SliceZone } from "@prismicio/react";
import { components } from "@/slices";
import { createClient } from "@/prismicio";

interface CampaignProps {
  linkId?: any | null
}

const Campaign: FC<CampaignProps> = ({ linkId }) => {

  const [campaignSlices, setCampaignSlices] = useState(null) as any
  
  useEffect(()=> {

    const getCampaign = async (linkId: any)=>{
      if (!linkId) {
        setCampaignSlices(null)
        return
      }

      const client = createClient()
      const response = await client.getByID(linkId) as any
      setCampaignSlices(response.data.slices)
    }
  
    getCampaign(linkId) as any

  }, [linkId])

  if(campaignSlices) {
    return (
      <section
        data-slice-type="component-campaign"
        className="py-10"
      >
        <SliceZone slices={campaignSlices} components={components} />
      </section>
    );
  }

  return null;
};

export default Campaign;
